import React, { Component } from 'react';
import BannerImg from '../../../Assets/images/Activation/activationBanner.webp';
import BannerIpadImg from '../../../Assets/images/Activation/activationBannerIPad.webp';
import Footer from '../../../components/Footer/Footer';
import SimpleHeader from '../../../components/Header/simpleHeader';
import './Activation.scss';
// import BannerMWebImg from '../../../Assets/images/Activation/activationBannerMWeb.webp';
import { store } from 'react-notifications-component';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import BackButton from '../../../Assets/images/commonImages/backButton.svg';
import circularTick from '../../../Assets/images/commonImages/greenTick.svg';
import dinersClub from '../../../Assets/images/dinersclub.png';
import amex from '../../../Assets/images/imgFiAmex.png';
import discoverImg from '../../../Assets/images/imgFiDiscover.png';
import visa from '../../../Assets/images/imgFiVisa.png';
import mastercard from '../../../Assets/images/mastercard.png';
import Button from '../../../components/Button/Button';
// import { pushTrackingEventsToGAAndFBNew } from '../../../global/commonFunctions/GaAndFb';
import { globalVal } from '../../../global/globalvalues';
import { activationPage } from '../../../global/texts/postActivation/activation';
import * as ActivationAction from '../../../store/Activation/actions';
import * as BillingAction from '../../../store/Billing/actions';
import * as Action from '../../../store/Checkout/actions';
import * as Action2 from '../../../store/TrackOrder/actions';
import firebase from '../../../utils/firebase';
import Step1 from './Step1';
import Step2 from './Step2';
import Step3 from './Step3';
import Step4 from './Step4';
// import ArrowRightIcon from '@material-ui/icons/ArrowRight';
// import AndriodIcon from '../../../Assets/images/BringYourPhone/checkCompatibility_and.png';
// import IosIcon from '../../../Assets/images/BringYourPhone/checkCompatibility_ios.png';
import AddLineUserDetails from '../../../components/AddLineUserDetails/AddLineUserDetails';
import PopOverImeiBox from '../../../components/ImeiComponent/ImeiPopOver';
import { isPaymentEnabled } from '../../../config';
import TagManager from 'react-gtm-module';
import { getUserName } from '../../../global/commonFunctions/getUserName';

type initialProps = {
    history: any;
    CheckoutActions: any;
    CheckoutState: any;
    ActivationActions: any;
    ActivationState: any;
    TrackOrderActions: any;
    TrackOrderState: any;
    BillingActions: any;
    BillingState: any;
};
type initialState = {
    isLoader: boolean;
    pages: any;
    isPrimary: boolean;
    currentPage: String;
    userData: any;
    payNowModal: boolean;
    payNowSuccess: boolean;
    payNowFail: boolean;
    amount: any;
    plan: any;
    couponCode: String;
    couponCodeErr: any;
    applyCouponClicked: boolean;
    textfieldCoupon: boolean;
    couponDetails: any;
    email: string;
    creditCards: any;
    modalLoading: boolean;
    buttonLoading: boolean;
    confirmClicked: boolean;
    faqClicked: boolean;
    isEsim: boolean;
    haveTrouble: boolean;
    target: any;
    simSwapInProgress: boolean;
};

const cardImages: Record<string, string> = {
    VISA: visa,
    MASTERCARD: mastercard,
    'AMERICAN EXPRESS': amex,
    'DINERS CLUB': dinersClub,
    DISCOVER: discoverImg,
    AMERICANEXPRESS: amex,
    DINERSCLUB: dinersClub,
};

export class Activation extends Component<initialProps, initialState> {
    ref: any = React.createRef();
    ref1: any = React.createRef();
    state: initialState = {
        pages: ['MainPage', 'Step1', 'Step2', 'Step3', 'Step4', 'ManageCard', 'UserDetailsPage'],
        currentPage: 'MainPage',
        isPrimary: true,
        userData: null,
        isLoader: true,
        payNowModal: false,
        payNowSuccess: false,
        payNowFail: false,
        amount: {
            totalAmount: 0,
            taxes: 0,
        },
        plan: null,
        couponCode: '',
        couponCodeErr: '',
        applyCouponClicked: false,
        textfieldCoupon: true,
        couponDetails: null,
        email: '',
        creditCards: null,
        modalLoading: false,
        buttonLoading: false,
        confirmClicked: false,
        faqClicked: false,
        isEsim: false,
        haveTrouble: false,
        target: null,
        simSwapInProgress: false,
    };
    componentDidMount() {
        if(!this.props.history?.location?.state?.redirectOnClick) {
            this.props.history.push('/post-activation-home')
        }
        setTimeout(() => {
            this.setState({
                isLoader: false,
            });
        }, 2000);
        let currentdetails: any = localStorage.getItem('customerDetail');
        currentdetails = JSON.parse(currentdetails);
        let occurence:any;
        let secondaryCustomer: any = localStorage.getItem('secondaryCustomerDetail');
        let fromPorting = localStorage.getItem('fromPorting');
        if(fromPorting) {
            localStorage.removeItem('fromPorting');
        }
        if (secondaryCustomer) {
            secondaryCustomer = JSON.parse(secondaryCustomer);
            occurence = secondaryCustomer?.peerAccountRef?.split('|')[2];
            this.setState({
                isEsim: secondaryCustomer.esim,
            });
        } else {
            if (currentdetails) {
                occurence = currentdetails?.peerAccountRef?.split('|')[2];
                this.setState({
                    isEsim: currentdetails.esim,
                });
            }
        }

        let user1: any = localStorage.getItem('currentuser');
        user1 = JSON.parse(user1);

        let email: string = user1 && user1.email ? user1.email : '';

        this.setState({ email });

        if (localStorage.getItem('reachSelectedPlanDetail')) {
            let plan: any = localStorage.getItem('reachSelectedPlanDetail');
            plan = JSON.parse(plan);

            if (plan && plan.plan) {
                this.setState({ plan: plan.plan });
            }
        } else {
            // this.props.TrackOrderActions.reachPlan({
            //     plan: currentdetails.reachPlanId,
            // });
        }

        if (currentdetails && !secondaryCustomer) {
            let cardHold = localStorage.getItem('card_hold');
            let manageCard = localStorage.getItem('manageCard');
            let simId = localStorage.getItem('simId');
            if (cardHold === 'true') {
                this.setState({ currentPage: 'Step4' });
            } else if (manageCard === 'true') {
                this.setState({ currentPage: 'Step3' });
            } else if (simId) {
                this.setState({ currentPage: 'Step3' });
            } else if (currentdetails && currentdetails.mnpInfo && currentdetails.isMNP) {
                this.setState({ currentPage: 'Step3' });
            }
            // else if (currentdetails.imei && currentdetails.make && currentdetails.model) {
            //     this.setState({ currentPage: 'Step2' });
            // }
            if (!currentdetails.firstName && !currentdetails.lastName) {
                this.setState({
                    currentPage: this.state.pages[6],
                });
            }

            this.setState({
                isPrimary: currentdetails && currentdetails.isPrimary,
                userData: currentdetails,
                isEsim: currentdetails.esim,
            });
            this.props.BillingActions.userPlans({ customerId: currentdetails && currentdetails.id });
        } else if (secondaryCustomer) {
            this.setState({
                isPrimary: secondaryCustomer.isPrimary,
                userData: secondaryCustomer,
                isEsim: secondaryCustomer.esim,
            });
            if (!secondaryCustomer.firstName || !secondaryCustomer.lastName) {
                this.setState({
                    currentPage: this.state.pages[6],
                });
            }
        }
        this.props.CheckoutActions.GetCustomer({
            username: encodeURIComponent(currentdetails && currentdetails.emailId),
        });
        isPaymentEnabled && this.props.ActivationActions.getCC({ customerId: currentdetails && currentdetails.id });
        TagManager.dataLayer({
            dataLayer: {
                event: "Activate",
                accountNo: currentdetails?.meta?.customer_statement_number,
                line_number: occurence,
            },
          });
        // this.GAAndFBEventsHandler("Activate", currentdetails?.meta?.customer_statement_number,occurence)
    }

    componentWillUnmount() {
        // localStorage.removeItem('secondaryCustomerDetail');
        localStorage.removeItem('simId');
        store.removeNotification('activationDefaultError');
    }

    componentDidUpdate(prevProps: initialProps) {
        let secondaryCustomer: any = localStorage.getItem('secondaryCustomerDetail');
        secondaryCustomer = JSON.parse(secondaryCustomer);
        let prev = prevProps && prevProps.CheckoutState;
        let cur = this.props && this.props.CheckoutState;
        const prev1 = prevProps && prevProps.TrackOrderState;
        const cur1 = this.props && this.props.TrackOrderState;

        if (prev1 !== cur1 && cur1?.ReachPlan && cur1?.ReachPlan?.data) {
            let user1: any = localStorage.getItem('customerDetail');
            let customerData = JSON.parse(user1);
            let totalSelectedLine = customerData ? customerData.extraLines + 1 : 1;
            let userPlan: any = {
                line: totalSelectedLine,
                plan: cur1.ReachPlan.data,
            };
            localStorage.setItem('reachSelectedPlanDetail', JSON.stringify(userPlan));
            localStorage.setItem('reachSelectedPlanLine', totalSelectedLine);

            if (userPlan && userPlan.plan) {
                this.setState({ plan: userPlan.plan });
            }
        }

        if (prev.coupon !== cur.coupon && cur.coupon && cur.coupon.status === 'SUCCESS' && cur.coupon.data) {
            localStorage.setItem('reachCoupon', cur.coupon.data);

            this.setState({
                textfieldCoupon: false,

                couponDetails: cur.coupon.data,
                applyCouponClicked: false,
            });
        }

        if (prev.getCustomer !== cur.getCustomer && cur.getCustomer && cur.getCustomer.data && !secondaryCustomer) {
            this.setState({
                isPrimary: cur.getCustomer.data && cur.getCustomer.data.isPrimary,
                userData: cur.getCustomer.data,
                isEsim: cur.getCustomer.data.esim,
            });
        } else if (
            prev.getCustomer !== cur.getCustomer &&
            cur.getCustomer &&
            cur.getCustomer.data &&
            cur.getCustomer.data.shipmentInfo &&
            Object.keys(cur.getCustomer.data.shipmentInfo)[0] &&
            !secondaryCustomer
        ) {
            this.setState({
                isPrimary: cur.getCustomer.data && cur.getCustomer.data.isPrimary,
                userData: cur.getCustomer.data,
                isEsim: cur.getCustomer.data.esim,
            });
        } 
        if (
            prev.getCustomer !== cur.getCustomer &&
            cur.getCustomer &&
            cur.getCustomer.data &&
            cur.getCustomer.data.operationsInProcess
        ) {
            if (cur.getCustomer.data.operationsInProcess.includes('SIM_SWAP_IN_PROGRESS')) {
                this.setState({
                    simSwapInProgress: true
                })
                let customerDetails: any = localStorage.getItem('customerDetail');
                customerDetails = JSON.parse(customerDetails);
                let timer: any = 60000;
                setTimeout(() => {
                    this.props.CheckoutActions.GetCustomer({
                        username: encodeURIComponent(customerDetails && customerDetails.emailId),
                    });
                }, timer);
            } else {
                this.setState({
                    simSwapInProgress: false
                })
            }
        }
    }
    backHandler = () => {
        const { currentPage, pages, userData } = this.state;

        if (userData.isPrimary && !this.props.history?.location?.state?.goBackToHome) {
            if (currentPage === pages[0] && !userData.esim) {
                this.props.history.push({ pathname: '/track-order', state: userData });
            } else {
                this.props.history.push({ pathname: '/activate-esim', state: userData });
            }
        } else {
            this.props.history.push('/post-activation-home');
        }
    };
    letGoHandler = () => {
        // pushTrackingEventsToGAAndFB({
        //     category: 'Activation',
        //     actionType: 'Lets Go',
        //     label: '',
        // });
        this.setState({ currentPage: 'step1', buttonLoading: false });
    };
    // GAAndFBEventsHandler = (buttonVal: string, accNumber?: any, lineNumber?:any) => {
    //     pushTrackingEventsToGAAndFBNew("event", buttonVal, {
    //       screenName: "Activation",
    //       buttonValue: buttonVal, 
    //       accNumber: accNumber,
    //       lineNumber: lineNumber,
    //     });
    //   };

    changeCurrentPage = async (val: any) => {
        let secondaryCustomer: any = localStorage.getItem('secondaryCustomerDetail');
        if (secondaryCustomer) {
            secondaryCustomer = JSON.parse(secondaryCustomer);
            this.setState({
                userData: secondaryCustomer,
            });
        }
        await this.setState({
            currentPage: val,
        });
    };

    getUserDetailsFromFirebase = (email: string) => {
        const thiss = this;
        isPaymentEnabled &&
            firebase
                .database()
                .ref('userWebJourneyData/' + btoa(email))
                .once('value')
                .then(
                    async function(snapshot: any) {
                        if (snapshot.val()) {
                            let userData = snapshot.val();
                            if (userData[0] && userData[0].selectedPlan && userData[0].selectedPlan.plan) {
                                thiss.setState({ plan: userData[0].selectedPlan.plan.name });
                            }
                        }
                    },
                    function(error) {
                        console.log(error);
                    },
                );
    };

    couponChangeHandler = (e: any) => {
        this.setState({
            couponCode: e.target.value,
            couponCodeErr: '',
        });
    };

    getCardImage = (cardType?: string) => {
        return cardType && cardImages[cardType?.toUpperCase()];
    };

    haveTroubleHandler = async () => {
        // pushTrackingEventsToGAAndFB({
        //     category: 'Check Compatibility',
        //     actionType: 'Having Trouble',
        // });
        let var1: any = await document.getElementById('having-trouble-div');
        await this.setState({ haveTrouble: true, target: var1 });
    };
    closeTroubleHandler = () => {
        this.setState({
            target: null,
            haveTrouble: false,
        });
    };
    convertToOrdinal(number: any) {
        const ordinalWords = ['First', 'Second', 'Third', 'Fourth', 'Fifth', 'Sixth'];
        const value = parseInt(number) - 1;
        return ordinalWords[value];
    }
    primaryName = () => {
        let customerDetail: any = localStorage.getItem('customerDetail');
        customerDetail = JSON.parse(customerDetail);

        return customerDetail?.firstName
            ? customerDetail?.firstName?.toUpperCase()
            : customerDetail?.lastName?.toUpperCase();
    };
    
    render() {
        const { currentPage, isPrimary, pages, userData, isEsim } = this.state;
        let now1: number;
        if (currentPage === pages[2]) {
            now1 = 50;
        } else if (currentPage === pages[3]) {
            now1 = 75;
        } else if (currentPage === pages[4]) {
            now1 = 100;
        } else {
            now1 = 25;
        }
        let customerDetail: any = localStorage.getItem('customerDetail');
        customerDetail = JSON.parse(customerDetail);
        let secondaryUser: any = localStorage.getItem('secondaryCustomerDetail');
        secondaryUser = JSON.parse(secondaryUser);
        let lineNumber: any = localStorage.getItem('lineNumber');
        lineNumber = JSON.parse(lineNumber);
        const points: any = [
            `Congrats! ${
                getUserName()
            }'s device is compatible with ${globalVal.long_name}.`,
            "Your device's IMEI ",
            "The 'Bring your number' information detailed in your Welcome Kit (skip this step for a new number).",
        ];
        return (
            <div className="ActivationMain">
                <SimpleHeader
                    history={this.props.history}
                    user={secondaryUser ? secondaryUser : customerDetail}
                    isHelp={true}
                />

                <div className="bannerImg">
                    <img src={BannerImg} alt="img" className="WebImg" />
                    <img src={BannerIpadImg} alt="img" className="IpadImg" />
                    {/* <img src={BannerMWebImg} alt="img" className="MWebImg" /> */}
                    <div className="contentCarousel">
                        <div className="Goodbye-mobile-store">
                            Activation
                        </div>
                    </div>
                </div>
                <div className="mediaQueryActivation">
                    <div className="ActivationMainContent">
                        {currentPage === 'MainPage' && (
                            <div className="backButtonActivation">
                                <img src={BackButton} alt="back" className="arrow_icon" onClick={this.backHandler} />
                                <div className="titleMainActivation">
                                    {isPrimary && currentPage === pages[0]
                                        ? activationPage.mainPage && `Activating ${getUserName()}'s Line`
                                        : !isPrimary && currentPage === pages[0]
                                        ? `Activating ${getUserName()}'s Line`
                                        : ''}
                                </div>
                            </div>
                        )}
                        {currentPage === pages[6] && (
                            <div className="backButtonActivation">
                                <img src={BackButton} alt="back" className="arrow_icon" onClick={this.backHandler} />
                                <div className="titleMainActivation">{`Enter User Details for ${secondaryUser ? this.convertToOrdinal(
                                    secondaryUser?.peerAccountRef?.split('|')[2],
                                ) : customerDetail?.firstName ? `${customerDetail?.firstName?.toUpperCase()}'s Line` : customerDetail?.lastName ? `${customerDetail?.lastName?.toUpperCase()}'s Line` : ''}`}</div>
                            </div>
                        )}
                        {currentPage === pages[6] ? (
                            <AddLineUserDetails
                                history={this.props.history}
                                userData={userData}
                                changeCurrentPage={this.changeCurrentPage}
                            />
                        ) : isPrimary && currentPage === pages[0] ? (
                            <div className="mainPageActivation">
                                {parseInt(userData && userData.extraLines) == 0 ? (
                                    <div className="subTitleActivation web">
                                        Let's get {this.primaryName()} on {globalVal.long_name}! Make sure you
                                        have:
                                    </div>
                                ) : (
                                    <div className="subTitleActivation web">
                                        You have {parseInt(userData && userData.extraLines) + 1} lines to activate.
                                        Let’s start with you! You’ll need:
                                    </div>
                                )}

                                {parseInt(userData && userData.extraLines) == 0 ? (
                                    <div className="subTitleActivation mobile">
                                        Let's get {this.primaryName()} on {globalVal.long_name}! Make sure you
                                        have:
                                    </div>
                                ) : (
                                    <>
                                        <div className="subTitleActivation mobile">
                                            You have {parseInt(userData && userData.extraLines) + 1} lines to activate.
                                        </div>
                                        <div className="subTitleActivation mobile">
                                            Let’s start with you! You’ll need:
                                        </div>
                                    </>
                                )}

                                <div className="infoAreaActivation">
                                    {!isEsim &&
                                        // activationPage.mainPage &&
                                        // activationPage.mainPage.points &&
                                        // activationPage.mainPage.points.length > 0 &&
                                        // activationPage.mainPage.points.map((el: any, index: number) => {
                                        points &&
                                        points.map((el: any, index: number) => {
                                            return (
                                                <div key={index} className="points">
                                                    <img src={circularTick} alt="" className="checkMark" />{' '}
                                                    <div className="point">
                                                        {el}{' '}
                                                        <span
                                                            className="secondaryText"
                                                            // onClick={() => window.open(globalVal.findIMEIUrl, '_blank')}
                                                        >
                                                            {index === 1 && <PopOverImeiBox />}
                                                        </span>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    {isEsim &&
                                        activationPage.mainPage &&
                                        activationPage.mainPage.eSimPoints &&
                                        activationPage.mainPage.eSimPoints.length > 0 &&
                                        activationPage.mainPage.eSimPoints.map((el: any, index: number) => {
                                            return (
                                                <div key={index} className="points">
                                                    <img src={circularTick} alt="" className="checkMark" />{' '}
                                                    <div className="point">
                                                        {el}{' '}
                                                        <span
                                                            className="secondaryText"
                                                            // onClick={() => window.open(globalVal.findIMEIUrl, '_blank')}
                                                        >
                                                            {index === 1 && <PopOverImeiBox />}
                                                        </span>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    <div className="letGoBtn">
                                        <Button
                                            primary={true}
                                            onClick={() => {
                                                this.props.CheckoutActions.UpdateCustomerSource({
                                                    customerId: userData?.id,
                                                    data: { activationJourneyStatus: 'IN_PROGRESS' },
                                                });
                                                this.changeCurrentPage('Step1');
                                            }}
                                        >
                                            Activate Line
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        ) : !isPrimary && currentPage === pages[0] ? (
                            <div className="mainPageActivation">
                                <div className="subTitleActivation">
                                    Let's get {getUserName()} on {globalVal.long_name}! Make sure you have:
                                </div>
                                <div className="infoAreaActivation">
                                    {!isEsim &&
                                        points &&
                                        points.map((el: any, index: number) => {
                                            return (
                                                <div key={index} className="points">
                                                    <img src={circularTick} alt="" className="checkMark" />{' '}
                                                    <div className="point">
                                                        {el}{' '}
                                                        <span
                                                            className="secondaryText"
                                                            // onClick={() => window.open(globalVal.findIMEIUrl, '_blank')}
                                                        >
                                                            {index === 1 && <PopOverImeiBox />}
                                                        </span>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    {isEsim &&
                                        activationPage.mainPage &&
                                        activationPage.mainPage.eSimPoints &&
                                        activationPage.mainPage.eSimPoints.length > 0 &&
                                        activationPage.mainPage.eSimPoints.map((el: any, index: number) => {
                                            return (
                                                <div key={index} className="points">
                                                    <img src={circularTick} alt="" className="checkMark" />{' '}
                                                    <div className="point">
                                                        {el}{' '}
                                                        <span
                                                            className="secondaryText"
                                                            // onClick={() => window.open(globalVal.findIMEIUrl, '_blank')}
                                                        >
                                                            {index === 1 && <PopOverImeiBox />}
                                                        </span>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    <div className="letGoBtn secondary">
                                        <Button
                                            primary={true}
                                            onClick={() => {
                                                this.changeCurrentPage('Step1');
                                                this.props.CheckoutActions.UpdateCustomerSource({
                                                    customerId: userData?.id,
                                                    data: { activationJourneyStatus: 'IN_PROGRESS' },
                                                });
                                            }}
                                            
                                        >
                                            Activate Line
                                        </Button>
                                    </div>
                                </div>
                                {activationPage.mainPageSecondary && activationPage.mainPageSecondary.tip && (
                                    <div className="note tips"></div>
                                )}
                            </div>
                        ) : (
                            <div className="StepsActivation">
                                {now1 === 50 ? (
                                    <Step2 history={this.props.history} changeCurrentPage={this.changeCurrentPage} 
                                        simSwapInProgress={this.state.simSwapInProgress} />
                                ) : now1 === 75 ? (
                                    <Step3 history={this.props.history} changeCurrentPage={this.changeCurrentPage} />
                                ) : now1 === 100 ? (
                                    <Step4 history={this.props.history} changeCurrentPage={this.changeCurrentPage} />
                                ) : (
                                    <Step1 history={this.props.history} changeCurrentPage={this.changeCurrentPage} />
                                )}
                            </div>
                        )}
                    </div>
                </div>
                <Footer isFixed={true} />
            </div>
        );
    }
}

function mapDispatchToProps(dispatch: any) {
    return {
        CheckoutActions: bindActionCreators(Action, dispatch),
        ActivationActions: bindActionCreators(ActivationAction, dispatch),
        TrackOrderActions: bindActionCreators(Action2, dispatch),
        BillingActions: bindActionCreators(BillingAction, dispatch),
    };
}

const mapStateToProps = (state: any) => ({
    CheckoutState: state.checkout,
    ActivationState: state.activation,
    TrackOrderState: state.trackOrder,
});

export default connect(mapStateToProps, mapDispatchToProps)(Activation);
